import i18n from "i18next";

// Tickets created from e-mails without a subject have an empty title; show a placeholder so they stay clickable and findable.
export const supportTicketTitle = (title?: string | null): string =>
    title?.trim() || i18n.t("no-title-warning");
